import { addStay_log } from "../log";
import { getLimit } from "../util/general_util";
import { Campground_Data, Trip_Cluster_v2 } from "../util/tripPlanner_types";
import { Campground } from "../util/type_defs";
import { add_poi_to_stop } from "./api_utils";
import { get_stop_from_stopID, handle_auto_lock, inc_interaction_counter } from "./util/helper_functions";

function check_poi_limit(addPOIMaxAmount:string|number, action:string) {
    if (addPOIMaxAmount != "inf") {
        let count:number = 0;
        window.tripPlannerCurrentTrip.legs.forEach(leg => {
            leg.clusters.forEach(cluster => {
                count += cluster.POIs.length
            });
        });
        if (count >= (addPOIMaxAmount as number)) {
            let msg:string = "To add more POIs to your trip,";

            if (action == 'freemiumShowSignup'){
                $("#signupModal").find("[signUpMsg]").html(msg);
                $("#signupModal").modal("show");
            }else{

                msg = msg + " purchase AdventureGenie Pro!";

                if(window.featureFlags.freeTrialState == "carded"){
                    $("#freemium-carded-trial").find("[signUpMsg]").html(msg);
                    $("#freemium-carded-trial").modal("show");
                }else{
                    $("#freemium-subscribe").find("[signUpMsg]").html(msg);
                    $("#freemium-subscribe").modal("show");
                }
            };
            return false;
        };
        return true;
    };
    return true;
};

export function handle_add_poi_click() {
    const stopID:string = this.getAttribute("stopID");

    let stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
    if (stopData == null) return;

    const poiID:number = parseInt(this.getAttribute("poiID"));
    if (Number.isNaN(poiID)) return;

    getLimit(['poi','addLimit']).then(async function(addPOI_max) {
        const addPOIMaxAmount:number|string = addPOI_max[0];
        const action:string = addPOI_max[1] as string;
        const belowLimit:boolean = check_poi_limit(addPOIMaxAmount, action);
        if (belowLimit) {

            if (!stopData.stop.fromUserQuery) {
                stopData = await handle_auto_lock(stopData);
                if (stopData == null) return;
            };

            $("[poi_disp]").find(`[poi_id="${poiID}"]`).remove();
            add_poi_to_stop(stopID, poiID).then(trip => {
                const directions = window.tripPlannerCurrentTrip.directions;
                trip.directions = directions;
                window.tripPlannerCurrentTrip = trip;

                document.dispatchEvent(new CustomEvent("trip.html.updated"));

                $(`a[href="#pois-${stopID}"]`).tab("show");
                $(`a[href="#pois-${stopID}"]`).trigger("shown.bs.tab");
                $("#ol_map_poi_popup_card").hide();

                inc_interaction_counter();
            }).catch(e => {
                console.error(e);
            });
        };
    });
};

export function remove_stay_from_stop(stop:Trip_Cluster_v2, campID:number) {
    let removedCamp:Campground_Data|null = null;
    for (let i:number = 0; i < stop.selectedCamps.length; i++) {
        if (stop.selectedCamps[i].camp.campID == campID) {
            removedCamp = stop.selectedCamps[i];
            stop.selectedCamps.splice(i,1);
            break;
        };
    };
    return removedCamp;
};

function get_highest_abs_CampID_forStop(stop: Trip_Cluster_v2) {
	let i: number;
	let highest = 0;
	for (i = 0; i < stop.selectedCamps.length; i++) {
		if (Math.abs(stop.selectedCamps[i].camp.campID) > highest) {
			highest = Math.abs(stop.selectedCamps[i].camp.campID)
		};
	};

	return highest;
};

function getNew_customStay_camp(stop: Trip_Cluster_v2, name: string): Campground {
	let new_customStay: Campground = {
		camp_name: name,
		campID: -1 * (get_highest_abs_CampID_forStop(stop) + 1),
		latitude: stop.coords.latitude,
		longitude: stop.coords.longitude,
		city: "",
		administrative_area_level_1: "",
		administrative_area_level_1_long: "",
		administrative_area_level_2: "",
		site_url: "",
		reserve_url: "",
		reserve_phone: "",
		info_phone: "",
		email: "",
		open_date: "",
		close_date: "",
		max_RV_width: -1,
		max_RV_height: -1,
		max_RV_length: -1,
		num_reviews: -1,
		ada_access: false,
		checkin_time: "",
		checkout_time: "",
		parkID: -1,
		genie_score: null,
		stock_img_url: "",
		price_low: -1,
		price_high: -1,
		street_address: "",
		num_sites: -1,
	};


	return new_customStay;
};


export function add_custom_stay_to_stop(stop:Trip_Cluster_v2, stayName:string) {
    let newCustomStay: Campground_Data = {
		camp: getNew_customStay_camp(stop, stayName),
		amenities: [],
		activities: [],
		affiliations: [],
		connectivity: [],
		discount: [],
		paymentMethod: [],

		is_fake_camp: true
	};

	if ("s_date" in stop && "numNights" in stop) {
		newCustomStay.s_date = stop.s_date;
		newCustomStay.numNights = stop.numNights;
		delete stop.s_date;
		delete stop.numNights;
	} else {
        newCustomStay.s_date = null;
		newCustomStay.numNights = 1;
	};

	stop.hasCustomStay = true;

	stop.selectedCamps.push(newCustomStay);

    return newCustomStay
};

export function add_stay_to_stop(stop:Trip_Cluster_v2, campID:number) {
    let newStay:Campground_Data|null = null;
    for (let i:number = 0; i < stop.altStops.length; i++) {
        if (stop.altStops[i].camp.campID == campID) {
            newStay = stop.altStops[i];
            stop.altStops.splice(i,1);
            break;
        };
    };
    if (newStay == null) return;
    stop.selectedCamps.push(newStay);

    addStay_log(newStay.camp.campID);

    if ("s_date" in stop && "numNights" in stop) {
        newStay.s_date = stop.s_date;
        if (stop.numNights == 0) {
            newStay.numNights = 1;
        } else {
            newStay.numNights = stop.numNights;
        };
        delete stop.s_date;
        delete stop.numNights;
    } else {
        newStay.s_date = null;
        newStay.numNights = null;
    }

    return newStay;
};